import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './App';
import { initializeAuth, useAuthStore } from './stores/authStore';
import { syncPushSubscription } from './services/pushNotifications';
import './styles/globals.css';

// Initialize auth state from localStorage
initializeAuth();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('Service worker registration failed', error);
    });
  });
}

// Self-heals a stale/lost push subscription so the phone/PWA stays reachable
// without prompting the user again: once on load, and again whenever the app
// regains focus (the common case for a phone that was backgrounded or asleep).
function maybeSyncPush() {
  if (useAuthStore.getState().isAuthenticated) {
    void syncPushSubscription();
  }
}
window.addEventListener('load', maybeSyncPush);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') maybeSyncPush();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
